import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  campaignToCreate: {
    corporate: '',
    campaignName: '',
    campaignLogo: '',
    enabled: false,
    bankId:'',
    authorizationType:'',
  },
  corporateAuthType:'',
  error: ''
}

export default function campaignCreate(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE:
      return createCampaignCampaignNameFieldChange(state, action)
    case actions.CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE:
      return createCampaignCampaignLogoFieldChange(state, action)
    case actions.CREATE_CAMPAIGN_ENABLED_FILED_CHANGE:
      return createCampaignEnabledChange(state, action)
    case actions.CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE:
      return createCampaignCorporateChange(state, action)
    case actions.CREATE_CAMPAIGN_CLEAN:
      return createCampaignClean(state, action)
    case actions.SAVE_CAMPAIGN_CREATE_FAILURE:
      return CreateCampaignError(state,action)
    case actions.CREATE_CAMPAIGN_AUTHORIZERS_CHANGE:
      return createCampaignAuthorizersChange(state,action)
    case actions.CREATE_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS:
      return createCampaignAuthorizersCheck(state,action)
    default:
      return state
  }
}

const CreateCampaignError = (state,action) => {
  return {
    ...state,
    error: action.error
  }
}



const createCampaignCorporateChange = (state, action) => {
  return update(
    state,
    {campaignToCreate: {corporate: {$set: action.value}}}
  )
}

const createCampaignAuthorizersChange = (state, action) => {
  return update(
      state,
      {campaignToCreate: {authorizationType: {$set: action.value}}}
  )
}

const createCampaignCampaignNameFieldChange = (state, action) => {
  return update(
    state,
    {campaignToCreate: {campaignName: {$set: action.value}}}
  )
}

const createCampaignCampaignLogoFieldChange = (state, action) => {
  return update(
    state,
    {campaignToCreate: {campaignLogo: {$set: action.value}}}
  )
}

const createCampaignEnabledChange = (state, action) => {
  return update(
    state,
    {campaignToCreate: {enabled: {$set: action.value}}}
  )
}

const createCampaignAuthorizersCheck = (state, action) => {
  return update(
      state,
      {corporateAuthType: {$set: action.value}}
  )
}

const createCampaignClean = (state, action) => {
  return initialState;
}